import { useLocation } from "react-router-dom";
import { applyUpdate, usePwa } from "@/lib/pwa";

// never shown on the writing sheet; it waits until the person leaves it
export const UpdateNotice = () => {
  const { updateReady } = usePwa();
  const onSheet = useLocation().pathname.startsWith("/escribir");
  if (!updateReady || onSheet) return null;
  return (
    <div role="status" data-testid="update-notice"
      className="fixed z-[44] left-4 right-4 bottom-[calc(6rem+env(safe-area-inset-bottom))] lg:left-auto lg:right-8 lg:bottom-8 lg:w-[340px] bg-hoja border border-linea rounded-[24px] px-5 py-4 flex items-center justify-between gap-4">
      <p className="text-[14px] text-tinta">Hay una versión nueva de Pensive</p>
      <button type="button" className="btn-secondary px-4 py-2 text-[14px]" onClick={applyUpdate} data-testid="update-apply-button">Actualizar</button>
    </div>
  );
};
